var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "EditView" },
    [
      !!_vm.to
        ? _c(
            "router-link",
            {
              staticClass: "EditViewButton",
              attrs: { to: _vm.to },
              on: {
                click: function ($event) {
                  return _vm.$emit("click", $event)
                },
              },
            },
            [_c("svg-view", { attrs: { name: "edit" } })],
            1
          )
        : _c(
            "div",
            {
              staticClass: "EditViewButton",
              on: {
                click: function ($event) {
                  return _vm.$emit("click", $event)
                },
              },
            },
            [_c("svg-view", { attrs: { name: "edit" } })],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }